import { useEffect, useState, useMemo, useCallback } from 'react'
import { ChessStatReq, ChessStatRes, Stat } from '@/services/types/history'
import { getBusinessChessStat, getStatById } from '@/services/history'
import icons from '@/assets/icons'
import images from '@/assets/images'
import { Picker } from 'antd-mobile'
import user from '@/stores/user'
import './index.less'

const gameMap = {
  // 0: '自由对弈',
  1: '残局挑战',
  2: '棋力闯关',
  3: '巅峰对决',
  // 4: '升级对弈',
}
enum GameSel {
  '残局挑战' = 1,
  '棋力闯关',
  '巅峰对决',
}
type Props = {
  playerId: string
  onTypeChange: (type: number) => void
}
const basicColumns = [
  [
    { label: '残局挑战', value: '1' },
    { label: '棋力闯关', value: '2' },
    { label: '巅峰对决', value: '3' },
  ],
]

const Card = ({ playerId, onTypeChange }: Props) => {
  const [stats, setStats] = useState<Stat[]>([])
  const [level, setLevel] = useState(0)
  const [winCount, setWinCount] = useState(0)
  const [value, setValue] = useState<(string | null)[]>([user.gameSel || '2'])

  const gameSel = useMemo(() => {
    user.gameSel = String(value)
    return Number(value[0]) as GameSel
  }, [value])

  const fetchStat = useCallback(async () => {
    const result = (await getStatById({
      user_ids: [playerId],
      game_mode: gameSel,
    })) as unknown as Stat[]
    setStats(
      result.map((item) => {
        if (item.total === 0) {
          item.rate = 0
        } else {
          item.rate = Math.round((item.win / item.total) * 100)
        }
        return item
      }),
    )
  }, [playerId, gameSel])
  const fetchPass = useCallback(async () => {
    try {
      const params: ChessStatReq = { playerId: playerId, mode: gameSel }
      const res = (await getBusinessChessStat(params)) as unknown as ChessStatRes
      console.log(res)
      setLevel(res.level)
      setWinCount(res.winCount)
    } catch (error) {}
  }, [playerId, gameSel])

  useEffect(() => {
    if (playerId) {
      fetchStat()
      if (gameSel === 1 || gameSel === 2) {
        fetchPass()
      }
    }
  }, [fetchStat, fetchPass, playerId, gameSel])

  useEffect(() => {
    onTypeChange(gameSel)
  }, [gameSel, onTypeChange])

  const gameBg = useMemo(() => {
    return gameSel === 1
      ? images.game1_bg
      : gameSel === 2
      ? images.game2_bg
      : gameSel === 3
      ? images.game3_bg
      : images.game2_bg
  }, [gameSel])

  return (
    <div className={`game-card card-${gameSel}`} style={{ backgroundImage: `url(${gameBg})` }}>
      <Picker columns={basicColumns} value={value} onConfirm={setValue}>
        {(items, { open }) => {
          return (
            <div className="game-type" onClick={open}>
              <span className="type-name">{gameMap[gameSel]}</span>
              <img className="icon-drop" src={icons.IconDropWhite} alt="" />
            </div>
          )
        }}
      </Picker>
      {gameSel === 1 ? (
        <div className={`game-center game1`}>
          <div className="pass">
            <div className="pass-title">胜率</div>
            <div className="pass-jn">
              <span className="pass-num">
                {stats[0] && stats[0].total !== 0
                  ? parseInt(String((stats[0].win / stats[0].total) * 100))
                  : 0}
              </span>
              <span className="pass-ji">%</span>
            </div>
          </div>
          <div className="pass pass-sub">
            <div className="pass-title">当前关卡</div>
            <div className="pass-jn">
              <span className="pass-ji">第</span>
              <span className="pass-num">{level}</span>
              <span className="pass-ji">关</span>
            </div>
          </div>
        </div>
      ) : undefined}
      {gameSel === 2 ? (
        <div className="game-center game2">
          <div className="pass">
            <div className="pass-title">胜率</div>
            <div className="pass-jn">
              <span className="pass-num">
                {stats[0] && stats[0].total !== 0
                  ? parseInt(String((stats[0].win / stats[0].total) * 100))
                  : 0}
              </span>
              <span className="pass-ji">%</span>
            </div>
          </div>
          <div className="pass pass-sub">
            <div className="pass-title">当前关卡</div>
            <div className="pass-jn">
              <span className="pass-ji">第</span>
              <span className="pass-num">{level}</span>
              <span className="pass-ji">关</span>
            </div>
          </div>
          <div className="stars stars-sub">
            {[1, 2, 3].slice(0, winCount).map((item, index) => (
              <img src={require('./pass-checked.png')} key={index} alt="" />
            ))}
            {[1, 2, 3].slice(0, 3 - winCount).map((item, index) => (
              <img src={require('./pass-default.png')} key={index} alt="" />
            ))}
          </div>
        </div>
      ) : undefined}
      {gameSel === 3 ? (
        <div className="game-center game3">
          <div className="pass">
            <div className="pass-title">胜率</div>
            <div className="pass-jn">
              <span className="pass-num">
                {stats[0] && stats[0].total !== 0
                  ? parseInt(String((stats[0].win / stats[0].total) * 100))
                  : 0}
              </span>
              <span className="pass-ji">%</span>
            </div>
          </div>
          <div className="pass pass-sub">
            <div className="pass-title">最高关卡</div>
            <div className="pass-jn">
              <span className="pass-ji">第</span>
              <span className="pass-num">26</span>
              <span className="pass-ji">关</span>
            </div>
          </div>
        </div>
      ) : undefined}
      <div className="game-nums">
        <span>总数</span>
        <span className="num">{stats[0]?.total}</span>
        <img className="divider" src={icons.IconDividerWhite} alt="" />
        <div className="num2">
          <span>胜</span>
          <span className="num">{stats[0]?.win}</span>
          <span>平</span>
          <span className="num">{stats[0]?.mate}</span>
          <span>负</span>
          <span className="num">{stats[0]?.lost}</span>
        </div>
      </div>
    </div>
  )
}

export default Card
